<template>
  <div>
  </div>
</template>

/*
This componenent is intended to be iframed and is used to initialize the plugins sdk.
Initilization involves... 
1: Fetching the comparison service status, e.g is it disabled, in test or live.
2: If the app level status is testing, then handle authentication to determine testing access.
It will post either a status reponse or an auth response message to the embedder window.
The response message will include the service state object for status or auth responses so that
service state can be cached and not looked up by other plugin components.
*/

<script>
  import Constants from '../../constants.js'

  import { inject, toRaw } from 'vue'

  import axios from 'axios'

  // import AuthUtil from '../../authUtil'

  export default {
    name: 'PluginInit',
    setup () {
      const firebaseApp = inject('firebase')
      return {
        firebaseApp
      }
    },
    data () {
      return {
        authenticated: false,
        currentUser: null,
        // serviceId: null,
        embedderId: null,
        context: null,
        // creatingAnonymousUser: false,
        // authStateUnsubscribe: null,
        serviceStatus: null
      }
    },
    mounted: function () {
      this.initialize()
    },
    methods:  {
      handleAuth: async function () {
        // Lazy import auth
        const { default: AuthUtil } = await import('../pluginsAuthUtil')
        // console.log('Dynamically imported authutil')
        AuthUtil.init(this.firebaseApp)
        // console.log('Dynamically imported authutil')

        // import { onAuthStateChanged } from "firebase/auth";
        const { onAuthStateChanged } = await import('firebase/auth');

        // console.log('Dynamically imported onAuthStateChanged')

        return new Promise((resolve, reject) => {
          const unsubscribe = onAuthStateChanged(AuthUtil.auth, (user) => {
              unsubscribe();
              if (user) {
                // console.log(`Have a current user ${AuthUtil.auth.currentUser.uid}`)
                this.currentUser = user
                this.authenticated = true
              }
              if (!this.authenticated) {
                // console.log('Not Authenticated')
                this.postResponse(toRaw(this.context), 'status', {serviceStatus: {status: 'disabled'}}, true)
              } else {
                // console.log('Authenticated so authorizing in testing mode')
                this.authorizeUser('testing')
              }
              resolve(user);
          }, reject);
        });

        // onAuthStateChanged(AuthUtil.auth, () => {
        //   if (AuthUtil.auth && AuthUtil.auth.currentUser) {
        //     // console.log(`Have a current user ${AuthUtil.auth.currentUser.uid}`)
        //     this.currentUser = AuthUtil.auth.currentUser
        //     this.authenticated = true
        //   }
        //   if (!this.authenticated) {
        //     // console.log('Not Authenticated')
        //     this.postResponse(this.context, 'status', {serviceStatus: {status: 'disabled'}}, true)
        //   } else {
        //     // console.log('Authenticated so authorizing in testing mode')
        //     this.authorizeUser('testing')
        //   }
        // })
      },
      initialize: function () {
        this.authenticated = false
        
        // const auth = AuthUtil.auth;
        // if (auth.currentUser) {
        //   this.authenticated = true
        // }

        // Require orgin domain and embedderId so we can run a method and send a response
        this.embedderId = this.$route.query['embedderId'] || null;
        // this.serviceId = this.$route.query['serviceId'] || null;

        if (this.embedderId) { // ID of the plugin connect iframe making this call
          if(this.buildContext()) {
            // In a development environment we check the services status first to determine if ther service is in test mode
            // In a production we skip this check for performance reasons.
            // const pikleEnv = this.context.env === 'production' ? 'production' : 'development'
            //
            // if (pikleEnv === 'production') {
            //   // In production activate the service immediately for UI performance.
            //   // In development mode the UI uses the authenticated and enabled hooks to init UI elements.
            //   this.postResponse(this.context, 'status', {serviceStatus: 'enabled'}, false) // Not exiting to allow async service mode to finish
            // }

            // Check the service status and authorize and check access if needed
            this.checkServiceStatus(/*this.serviceId*/).then(response => {
              this.serviceStatus = response
              const serviceMode = response.status
              if (serviceMode === 'testing') {

                this.handleAuth()

              // } else if (serviceMode === 'disabled' || pikleEnv === 'production') {
              } else {
                this.postResponse(toRaw(this.context), 'status', {serviceStatus: toRaw(this.serviceStatus)}, true)
              }
              // TODO handle if live but not in production. Show an error maybe?

              // if (serviceMode === 'disabled') {
              //   this.postResponse(this.context, 'status', {serviceStatus: serviceMode}, true)
              // }
              // else if (serviceMode === 'testing' && !this.authenticated) {
              //   this.postResponse(this.context, 'status', {serviceStatus: 'disabled'}, true)
              // }
              // else {
              //   // Authorize given a service mode.
              //   // This may disable the service due to the user not having access.
              //   this.authorizeUser(serviceMode)
              // }
            })
          }
        }
      },
      checkServiceStatus: async function (/*serviceIdentifier*/) {
        let res = 'disabled'
        // R.B a suggestion for handling other service types
        // Get service endpoint from identifier
        // let serviceEndpoint = null
        // switch(serviceIdentifier) {
        //   case 'comparison':
        //     serviceEndpoint = 'comparesdk'
        //     break;
        //   default:
        //     handled = null
        // }
        // // If we support the service than check it
        // if (serviceEndpoint) {
        const statusURL = `${Constants.JSSDK_API_BASE_PATH}/comparesdk/mode`

        // Lazy import auth
        // const { default: AuthUtil } = await import('../../authUtil')
        // if (!AuthUtil.appCheck) {
        //   AuthUtil.initAppCheck(this.$firebaseApp)
        // }

        // const appCheckToken = await AuthUtil.getAppCheckToken()

        const response = await axios.post(statusURL, {appKey: this.context.appKey}, {
          headers: {
            'Content-Type': 'application/json'
            // 'X-Firebase-AppCheck': appCheckToken
          }
        })
        // Set result according to true if the response status is active
        if (response && response.status === 200 && response.data) {
          // res = response.data.status
          res = response.data || null
        }
        // }

        return res
      },
      checkServiceAccess: async function (/*serviceIdentifier*/) {
        if (!this.authenticated) {
          return false
        }

        let res = false
        // R.B a suggestion for handling other service types
        // Get service endpoint from identifier
        // let serviceEndpoint = null
        // switch(serviceIdentifier) {
        //   case 'comparison':
        //     serviceEndpoint = 'comparesdk'
        //     break;
        //   default:
        //     handled = null
        // }
        // // If we support the service than check it
        // if (serviceEndpoint) {

        const token = this.currentUser && (await this.currentUser.getIdToken())

        const { default: AuthUtil } = await import('../pluginsAuthUtil')
        if (!AuthUtil.appCheck) {
          AuthUtil.initAppCheck(this.firebaseApp)
        }
        const appCheckToken = await AuthUtil.getAppCheckToken()

        const accessURL = `${Constants.JSSDK_API_BASE_PATH}/comparesdk/access`

        const response = await axios.post(accessURL, {appKey: this.context.appKey}, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
            'X-Firebase-AppCheck': appCheckToken
          }
        })
        // Set result according to true if the response status is active
        if (response && response.status === 200 && response.data) {
          // res = response.data.status === 'active'
          res = response.data.hasAccess
        }
        // }

        return res
      },
      buildContext: function () {
        let success = false
        this.context = {}
        const queryParams = this.$route.query['params'] || null
        // console.log(`Decode params ${JSON.parse(queryParams)}`)
        if (queryParams) {
          const embedderParams = JSON.parse(decodeURIComponent(queryParams))
          this.context = {...embedderParams}
          if (this.context.appKey && this.context.origin) {
            success = true
          }
        }
        return success
      },
      authorizeUser: async function (serviceMode) {
        // If we have a user, check if they have access given a known service mode
        if (this.authenticated) {
          // Check if compare service is enabled
          if (serviceMode === 'testing') {
            const hasAccess = await this.checkServiceAccess(/*this.serviceId*/)
            if (hasAccess) {
              const responseBody = {serviceStatus: this.serviceStatus, authenticated: true, authStateChanged: false, uid: this.currentUser.uid}
              // console.log(`Have testing access. Posting response ${JSON.stringify(responseBody)}`)
              this.postResponse(toRaw(this.context), 'auth', responseBody, true)
            } else {
              this.postResponse(toRaw(this.context), 'auth', {serviceStatus: {status: 'disabled'}, error: {status: 'disabled', message: 'The comparison service is not enabled for the current user'}}, true)
            }
          } else {
            const shouldExit = serviceMode !== null;//envMode !== 'production'
            this.postResponse(toRaw(this.context), 'auth', {serviceStatus: toRaw(this.serviceStatus), authenticated: true, authStateChanged: false}, shouldExit)
          }

        }

        // If we have no user, and the service is fully enabled
        // we can create a new anonymous user
        // else if (serviceMode === 'enabled') {
        //   const self = this
        //   try {
        //     // Listen for a sign in and register the new user as anonymous so we can manage account merging and account deletion for dormant anonymous users
        //     this.authStateUnsubscribe = firebase.auth().onAuthStateChanged((user) => {
        //       if (user) {
        //         // User is signed in
        //         self.registerAnonymousUser()
        //       }
        //     });
        //
        //     // Sign in the anonymous user
        //     firebase.auth().signInAnonymously()
        //
        //   } catch(error) {
        //     var errorCode = error.code;
        //     var errorMessage = error.message;
        //     self.postResponse(this.context, {error: {message: errorMessage, code: errorCode}}, true)
        //   }
        // }
      },
      // registerAnonymousUser: async function () {
      //   const token = firebase.auth().currentUser && (await firebase.auth().currentUser.getIdToken())
      //   const anonymousUserURL = `${Constants.JSSDK_API_BASE_PATH}/comparesdk/registeranonymous`
      //
      //   if (this.authStateUnsubscribe) {
      //     this.authStateUnsubscribe()
      //   }
      //
      //   await axios.post(anonymousUserURL, {}, {
      //     headers: {
      //       'Content-Type': 'application/json',
      //       'Authorization': `Bearer ${token}`,
      //     }
      //   })
      //
      //   this.postResponse(this.context, 'auth', {authenticated: true, authStateChanged: true}, true)
      // },
      postResponse: function (context, eventType, payload, exit) {
        const contextObj = {event: eventType, ...context}
        const messageData = {action: 'init', context: contextObj, ...payload}
        window.parent.postMessage(messageData, context.origin)
        if (exit) {
          this.postExit(payload, context.origin)
        }
      },
      postExit: function (payload, origin) {
        const messageData = {action: 'exit', embedder: this.embedderId, ...payload}
        window.parent.postMessage(messageData, origin)
      }
    }
  }
</script>
